// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 855 ? "my-crossdock-main" : chunkId) + "." + {"156":"e682673024cf93b95d90","419":"d59d588542fe361957e0","525":"49a5eb9342fd27f21bb7","720":"5d85b9c579aeacd89b59","855":"5ef5ed59fd8d7f92c19e"}[chunkId] + ".js";
};